import React, {
	InputHTMLAttributes,
	LabelHTMLAttributes,
	forwardRef,
	HTMLAttributes,
} from 'react'
import './index.scss'
import clsx from 'clsx'

export function InputContainer({
	className,
	...rest
}: HTMLAttributes<HTMLDivElement>) {
	return <div className={clsx('input-container', className)} {...rest} />
}

export function InputLabel({
	className,
	...rest
}: LabelHTMLAttributes<HTMLLabelElement>) {
	return <label className={clsx('input-label')} {...rest} />
}

export const InputField = forwardRef<
	HTMLInputElement,
	InputHTMLAttributes<HTMLInputElement>
>(function ({ children, className, ...rest }, ref) {
	return (
		<div className="input-field-container">
			<input
				className={clsx('input-field', className)}
				{...rest}
				ref={ref}
			/>
			{children}
		</div>
	)
})

export function InputDescription({
	className,
	...rest
}: HTMLAttributes<HTMLSpanElement>) {
	return <span className={clsx('input-description', className)} {...rest} />
}

export function InputError({
	className,
	...rest
}: HTMLAttributes<HTMLSpanElement>) {
	return <span className={clsx('input-error', className)} {...rest} />
}

export function InputFieldRight({
	className,
	...rest
}: HTMLAttributes<HTMLSpanElement>) {
	return <span className={clsx('input-right', className)} {...rest} />
}

export const Input = {
	Container: InputContainer,
	Label: InputLabel,
	Field: InputField,
	FieldRight: InputFieldRight,
	Description: InputDescription,
	Error: InputError,
}
